module.exports = __webpack_public_path__ + "static/media/dca_bob.ce8a3903.png";